import styled from '@emotion/styled';
import { settingsTheme as t } from '../theme';

interface CardProps {
  /** Activa cursor y realce al pasar el mouse cuando la tarjeta es clicable. */
  interactive?: boolean;
  /** Pinta la superficie en grises para estados deshabilitados. */
  muted?: boolean;
}

/**
 * Primitivo de superficie: la caja blanca con borde, radio y sombra suave.
 * No conoce su contenido; cualquier composición la usa como lienzo.
 */
const Card = styled.div<CardProps>(({ interactive, muted }) => ({
  position: 'relative',
  background: muted ? t.color.disabledSurface : t.color.surface,
  border: `1px solid ${muted ? t.color.disabledBorder : t.color.border}`,
  borderRadius: t.radius.lg,
  padding: 24,
  boxShadow: muted ? 'none' : t.shadow.card,
  transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
  cursor: interactive ? 'pointer' : 'default',
  ...(interactive
    ? {
        '&:hover': {
          borderColor: t.color.borderHover,
          boxShadow: t.shadow.cardHover,
        },
      }
    : {}),
}));

export default Card;
